export interface CodeEntry {
  digits: string[];
  activeDigit: number;
}

export function pickDigit(entry: CodeEntry, digit: string): CodeEntry {
  if (!/^\d$/.test(digit)) return entry;
  if (entry.activeDigit < 0 || entry.activeDigit >= entry.digits.length) return entry;
  if (entry.digits.some((value, index) => value === digit && index !== entry.activeDigit)) return entry;

  const digits = [...entry.digits];
  digits[entry.activeDigit] = digit;
  const nextEmpty = digits.findIndex((value, index) => index > entry.activeDigit && value === "");
  const firstEmpty = digits.indexOf("");
  return {
    digits,
    activeDigit: nextEmpty >= 0 ? nextEmpty : firstEmpty >= 0 ? firstEmpty : entry.activeDigit,
  };
}

export function eraseDigit(entry: CodeEntry): CodeEntry {
  const activeDigit = entry.digits[entry.activeDigit] ? entry.activeDigit : Math.max(0, entry.activeDigit - 1);
  const digits = [...entry.digits];
  digits[activeDigit] = "";
  return { digits, activeDigit };
}

export function clearCode(length: number): CodeEntry {
  return { digits: Array<string>(length).fill(""), activeDigit: 0 };
}

export function isDigitUsed(entry: CodeEntry, digit: string): boolean {
  const complete = entry.digits.every(Boolean);
  return entry.digits.some((value, index) => value === digit && (complete || index !== entry.activeDigit));
}
